import { render } from "./ElemEqui.vue?vue&type=template&id=845e36a4"
import script from "./ElemEqui.vue?vue&type=script&lang=js"
export * from "./ElemEqui.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__